<template>
  <div>
    <!--登入成功-->
    <div v-if="noticeMessage" class="popup-wrap text-center" :class="{ active: noticeMessage }">
      <div class="popup-box">
        <div class="popup-success">
          <!-- eslint-disable-next-line -->
          <h5 v-if="isHtml" v-html="message" />
          <!-- Render message as text if it does not contain HTML tags -->
          <h5 v-else>
            {{ message }}
          </h5>
          <button v-if="noticeMessage && noticeMessage.close !=='callAPI'" class="button-style-5" @click="submit">
            <span>{{ submitLabel }}</span>
          </button>
          <button v-if="noticeMessage && noticeMessage.close ==='callAPI'" class="button-style-5" @click="submit">
            <span>YES</span>
          </button>
          <button v-if="noticeMessage && noticeMessage.close ==='callAPI'" class="button-style-5" @click="hideModal">
            <span>NO</span>
          </button>
        </div>
        <a v-if="noticeMessage.message !== $t('Bao.credit_card_notice1')" class="popup-close" @click="hideModal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  data() {
    return {
      isHtml: false
    }
  },
  computed: {
    noticeMessage() {
      return this.$store.getters.noticeMessage
    },
    message() {
      if (!this.noticeMessage) {
        return null
      }

      return this.$te(this.noticeMessage.message) ? this.$t(this.noticeMessage.message) : this.noticeMessage.message
    },
    submitLabel() {
      const isUseOKText = this.noticeMessage.isUseOKText
      if (isUseOKText) {
        return isUseOKText
      } else {
        return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK'
      }
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (newVal === 'closeModal') {
        this.hideModal()
      } else if (newVal != null) {
        if (this.message.indexOf('<') > -1) {
          this.isHtml = true
        } else {
          this.isHtml = false
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    hideModal() {
      const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '')
      const firstSegment = pathSegments[0]

      this.$store.commit('SET_NOTICE_MESSAGE', null)
      if (firstSegment === 'campaign') {
        this.$router.push('/').then(() => {
          window.location.reload()
        })
      }
    },
    submit() {
      const func = this.noticeMessage.func
      const close = this.noticeMessage.close
      const msg = this.noticeMessage.message
      if (msg === this.$t('Bao.free_spin_double_check') && close) {
        this.$store.commit('SET_CONFIRM_PURCHASE', true)
      }

      if (close) {
        this.hideModal()
        if (close === 'callAPI') {
          this.$store.commit('SET_API_EXECUTE', true)
        }
      }
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>
